var _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 72,
    viewBox: "0 0 179 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 67",
    filter: "url(#filter0_d_751_4980)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 4,
    width: 154,
    height: 48,
    rx: 12,
    fill: "url(#paint0_linear_751_4980)",
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4.5,
    width: 153,
    height: 47,
    rx: 11.5,
    stroke: "#3F237C",
    style: {
      stroke: "#3F237C",
      stroke: "color(display-p3 0.2458 0.1358 0.4865)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0587 26.9237C47.026 23.3784 50.036 21.6536 50.1736 21.5733C48.4689 19.15 45.8267 18.8189 44.8982 18.7925C42.679 18.5648 40.5264 20.0872 39.3959 20.0872C38.2429 20.0872 36.5021 18.8145 34.6259 18.8519C32.2115 18.8882 29.9528 20.2511 28.7141 22.3675C26.1575 26.6828 28.0642 33.0243 30.5135 36.5124C31.7388 38.2207 33.1705 40.1281 35.0444 40.061C36.8777 39.9873 37.5626 38.9214 39.775 38.9214C41.9671 38.9214 42.6102 40.061 44.5213 40.0181C46.4889 39.9873 47.7277 38.3021 48.9101 36.5784C50.326 34.6204 50.8946 32.6921 50.9171 32.5931C50.8709 32.5777 47.0959 31.173 47.0587 26.9237Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4484 16.4979C44.4345 15.2956 45.1091 13.6599 44.9219 12C43.4947 12.0616 41.7099 12.9625 40.6821 14.1384C39.7727 15.1746 38.9604 16.873 39.1703 18.4702C40.7734 18.5868 42.4195 17.6815 43.4484 16.4979Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Download on the"
  }, /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M68.4067 16.1712C68.4067 17.4659 68.0085 18.4405 67.2131 19.095C66.4764 19.6989 65.4294 20.0014 64.0733 20.0014C63.4009 20.0014 62.8255 19.9728 62.3438 19.9156V12.8415C62.9722 12.7425 63.6491 12.6919 64.3802 12.6919C65.672 12.6919 66.6456 12.9658 67.3022 13.5136C68.0378 14.1329 68.4067 15.0184 68.4067 16.1712ZM67.1601 16.2031C67.1601 15.3638 66.9322 14.7203 66.4764 14.2715C66.0206 13.8238 65.3549 13.5994 64.4783 13.5994C64.106 13.5994 63.789 13.6236 63.5261 13.6742V19.0521C63.6716 19.0741 63.9379 19.084 64.3249 19.084C65.2297 19.084 65.9281 18.8387 66.42 18.3481C66.9119 17.8575 67.1601 17.1425 67.1601 16.2031Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M75.0165 17.3019C75.0165 18.0994 74.783 18.7528 74.3159 19.2654C73.8263 19.7923 73.1776 20.0552 72.3675 20.0552C71.5868 20.0552 70.9652 19.8033 70.5015 19.2973C70.0389 18.7924 69.8076 18.1555 69.8076 17.3877C69.8076 16.5847 70.0457 15.9258 70.524 15.4143C71.0024 14.9028 71.6455 14.6465 72.4555 14.6465C73.2362 14.6465 73.8635 14.8984 74.3385 15.4033C74.7898 15.8939 75.0165 16.5275 75.0165 17.3019ZM73.7902 17.3393C73.7902 16.8608 73.6841 16.4505 73.4732 16.1084C73.225 15.6948 72.8718 15.488 72.4126 15.488C71.9377 15.488 71.5766 15.6948 71.3284 16.1084C71.1163 16.4505 71.0114 16.8674 71.0114 17.3602C71.0114 17.8387 71.1175 18.249 71.3284 18.5911C71.5845 19.0047 71.9411 19.2115 72.4014 19.2115C72.8526 19.2115 73.2069 19.0014 73.4619 18.5801C73.6807 18.2314 73.7902 17.8178 73.7902 17.3393Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M83.8795 14.7524L82.2154 19.9378H81.1323L80.443 17.6861C80.2681 17.124 80.1259 16.5652 80.0154 16.0108H79.9939C79.8913 16.5806 79.7491 17.1383 79.5663 17.6861L78.8341 19.9378H77.7386L76.1738 14.7524H77.3889L77.9902 17.2175C78.1358 17.8005 78.2554 18.356 78.3513 18.8818H78.3727C78.4607 18.4484 78.6062 17.8962 78.8116 17.2285L79.5663 14.7535H80.5298L81.253 17.1757C81.4279 17.7664 81.57 18.3351 81.6795 18.8829H81.7122C81.7923 18.3494 81.913 17.7807 82.0732 17.1757L82.7185 14.7535H83.8795V14.7524Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M90.0094 19.9374H88.827V16.9674C88.827 16.0522 88.4705 15.5946 87.7552 15.5946C87.4044 15.5946 87.1212 15.72 86.9012 15.9719C86.6834 16.2238 86.5729 16.5208 86.5729 16.8607V19.9363H85.3905V16.2337C85.3905 15.7783 85.3759 15.2844 85.3477 14.7498H86.3867L86.442 15.5605H86.4747C86.6124 15.3086 86.8177 15.1007 87.0873 14.9346C87.4078 14.741 87.7665 14.6431 88.1591 14.6431C88.6555 14.6431 89.0685 14.7993 89.3968 15.1128C89.8052 15.4967 90.0094 16.0698 90.0094 16.831V19.9374Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M93.2701 19.9377H92.0889V12.373H93.2701V19.9377Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "o_2",
    d: "M100.231 17.3019C100.231 18.0994 99.9978 18.7528 99.5308 19.2654C99.0411 19.7923 98.3913 20.0552 97.5824 20.0552C96.8005 20.0552 96.1789 19.8033 95.7163 19.2973C95.2537 18.7924 95.0225 18.1555 95.0225 17.3877C95.0225 16.5847 95.2605 15.9258 95.7389 15.4143C96.2172 14.9028 96.8603 14.6465 97.6692 14.6465C98.4511 14.6465 99.0772 14.8984 99.5533 15.4033C100.005 15.8939 100.231 16.5275 100.231 17.3019ZM99.0039 17.3393C99.0039 16.8608 98.8978 16.4505 98.6869 16.1084C98.4398 15.6948 98.0855 15.488 97.6275 15.488C97.1514 15.488 96.7904 15.6948 96.5433 16.1084C96.3312 16.4505 96.2263 16.8674 96.2263 17.3602C96.2263 17.8387 96.3323 18.249 96.5433 18.5911C96.7994 19.0047 97.1559 19.2115 97.6162 19.2115C98.0675 19.2115 98.4206 19.0014 98.6756 18.5801C98.8956 18.2314 99.0039 17.8178 99.0039 17.3393Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M105.953 19.9375H104.891L104.803 19.3402H104.771C104.407 19.8165 103.89 20.0552 103.217 20.0552C102.715 20.0552 102.309 19.8979 102.003 19.5855C101.726 19.3017 101.587 18.9486 101.587 18.5295C101.587 17.8959 101.858 17.413 102.403 17.0786C102.946 16.7442 103.711 16.5803 104.696 16.588V16.4912C104.696 15.8081 104.328 15.4671 103.592 15.4671C103.067 15.4671 102.605 15.5958 102.205 15.851L101.965 15.0942C102.459 14.7961 103.069 14.6465 103.789 14.6465C105.179 14.6465 105.876 15.3615 105.876 16.7915V18.7011C105.876 19.2192 105.902 19.6317 105.953 19.9375ZM104.726 18.1555V17.3558C103.421 17.3338 102.769 17.6825 102.769 18.4008C102.769 18.6714 102.844 18.8738 102.996 19.0091C103.148 19.1444 103.342 19.2115 103.574 19.2115C103.833 19.2115 104.076 19.1312 104.297 18.9717C104.519 18.8111 104.656 18.6076 104.706 18.3579C104.719 18.3018 104.726 18.2336 104.726 18.1555Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M112.672 19.9377H111.622L111.567 19.105H111.534C111.199 19.7386 110.628 20.0554 109.826 20.0554C109.185 20.0554 108.652 19.8101 108.229 19.3195C107.806 18.8289 107.595 18.192 107.595 17.4099C107.595 16.5706 107.824 15.8908 108.284 15.3716C108.73 14.8876 109.276 14.6456 109.926 14.6456C110.64 14.6456 111.14 14.8799 111.424 15.3496H111.446V12.373H112.63V18.5407C112.63 19.0456 112.643 19.5109 112.672 19.9377ZM111.446 17.7509V16.8863C111.446 16.7367 111.435 16.6157 111.414 16.5233C111.347 16.2461 111.204 16.0129 110.986 15.8248C110.766 15.6367 110.501 15.5421 110.195 15.5421C109.754 15.5421 109.409 15.7126 109.155 16.0547C108.903 16.3968 108.776 16.8335 108.776 17.367C108.776 17.8796 108.897 18.2954 109.139 18.6155C109.395 18.9565 109.741 19.127 110.173 19.127C110.561 19.127 110.871 18.9851 111.107 18.7002C111.335 18.4373 111.446 18.1205 111.446 17.7509Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "o_3",
    d: "M122.784 17.3019C122.784 18.0994 122.551 18.7528 122.083 19.2654C121.594 19.7923 120.946 20.0552 120.135 20.0552C119.356 20.0552 118.734 19.8033 118.269 19.2973C117.806 18.7924 117.575 18.1555 117.575 17.3877C117.575 16.5847 117.813 15.9258 118.292 15.4143C118.77 14.9028 119.413 14.6465 120.224 14.6465C121.004 14.6465 121.632 14.8984 122.106 15.4033C122.557 15.8939 122.784 16.5275 122.784 17.3019ZM121.559 17.3393C121.559 16.8608 121.453 16.4505 121.242 16.1084C120.993 15.6948 120.641 15.488 120.18 15.488C119.706 15.488 119.345 15.6948 119.096 16.1084C118.884 16.4505 118.779 16.8674 118.779 17.3602C118.779 17.8387 118.885 18.249 119.096 18.5911C119.352 19.0047 119.709 19.2115 120.169 19.2115C120.62 19.2115 120.976 19.0014 121.231 18.5801C121.448 18.2314 121.559 17.8178 121.559 17.3393Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "n_2",
    d: "M129.141 19.9374H127.96V16.9674C127.96 16.0522 127.603 15.5946 126.887 15.5946C126.536 15.5946 126.253 15.72 126.034 15.9719C125.815 16.2238 125.706 16.5208 125.706 16.8607V19.9363H124.522V16.2337C124.522 15.7783 124.509 15.2844 124.48 14.7498H125.518L125.574 15.5605H125.606C125.745 15.3086 125.951 15.1007 126.219 14.9346C126.541 14.741 126.898 14.6431 127.292 14.6431C127.787 14.6431 128.2 14.7993 128.528 15.1128C128.938 15.4967 129.141 16.0698 129.141 16.831V19.9374Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M137.098 15.6158H135.796V18.1348C135.796 18.775 136.028 19.0951 136.486 19.0951C136.698 19.0951 136.874 19.0775 137.013 19.0412L137.043 19.9157C136.81 20.0015 136.503 20.0444 136.125 20.0444C135.658 20.0444 135.294 19.9058 135.032 19.6286C134.768 19.3514 134.637 18.885 134.637 18.2305V15.6158H133.859V14.7523H134.637V13.8019L135.795 13.4609V14.7512H137.097V15.6158H137.098Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M143.357 19.9377H142.174V16.9897C142.174 16.0602 141.817 15.5949 141.103 15.5949C140.555 15.5949 140.18 15.8644 139.975 16.4034C139.94 16.5167 139.92 16.6553 139.92 16.8181V19.9366H138.738V12.373H139.92V15.4981H139.942C140.314 14.9294 140.848 14.6456 141.54 14.6456C142.029 14.6456 142.434 14.8018 142.756 15.1153C143.156 15.5058 143.357 16.0866 143.357 16.8544V19.9377Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M149.814 17.0996C149.814 17.3064 149.798 17.4802 149.77 17.6221H146.224C146.24 18.1347 146.409 18.5252 146.738 18.7958C147.038 19.0378 147.425 19.1588 147.899 19.1588C148.423 19.1588 148.902 19.0774 149.332 18.9135L149.518 19.7143C149.013 19.9277 148.42 20.0344 147.733 20.0344C146.909 20.0344 146.26 19.7979 145.791 19.3249C145.319 18.8519 145.086 18.2172 145.086 17.4208C145.086 16.6387 145.304 15.9875 145.743 15.4683C146.201 14.9139 146.82 14.6367 147.602 14.6367C148.367 14.6367 148.948 14.9139 149.34 15.4683C149.657 15.9083 149.814 16.4528 149.814 17.0996ZM148.686 16.8015C148.695 16.4594 148.617 16.1646 148.457 15.916C148.252 15.5959 147.939 15.4353 147.516 15.4353C147.13 15.4353 146.815 15.5915 146.575 15.905C146.379 16.1547 146.263 16.4528 146.224 16.8015H148.686Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "App Store"
  }, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M73.5914 39.8156H71.0292L69.6258 35.5157H64.7474L63.4105 39.8156H60.916L65.7492 25.1768H68.7345L73.5914 39.8156ZM69.2027 33.7117L67.9335 29.8892C67.7992 29.4987 67.5476 28.5791 67.1764 27.1315H67.1313C66.9835 27.7541 66.7454 28.6737 66.4183 29.8892L65.1716 33.7117H69.2027Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M86.0214 34.4082C86.0214 36.2034 85.5239 37.6224 84.5288 38.6641C83.6375 39.5914 82.5308 40.0545 81.2096 40.0545C79.7836 40.0545 78.7592 39.5551 78.1353 38.5563H78.0902V44.1168H75.6848V32.7351C75.6848 31.6065 75.6544 30.4482 75.5957 29.2602H77.7111L77.8453 30.9333H77.8905C78.6926 29.6727 79.91 29.0435 81.5436 29.0435C82.8207 29.0435 83.8869 29.5352 84.7398 30.5197C85.595 31.5053 86.0214 32.8011 86.0214 34.4082ZM83.571 34.494C83.571 33.4666 83.3341 32.6196 82.858 31.953C82.3379 31.2578 81.6395 30.9102 80.764 30.9102C80.1706 30.9102 79.6313 31.1038 79.1495 31.4855C78.6667 31.8705 78.3508 32.3732 78.203 32.9958C78.1285 33.2862 78.0913 33.5238 78.0913 33.7108V35.4708C78.0913 36.2386 78.3327 36.8865 78.8156 37.4156C79.2985 37.9447 79.9258 38.2087 80.6974 38.2087C81.6034 38.2087 82.3085 37.8677 82.8128 37.1879C83.3183 36.507 83.571 35.6094 83.571 34.494Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "p_2",
    d: "M98.4734 34.4082C98.4734 36.2034 97.9759 37.6224 96.9797 38.6641C96.0895 39.5914 94.9828 40.0545 93.6616 40.0545C92.2356 40.0545 91.2112 39.5551 90.5884 38.5563H90.5433V44.1168H88.138V32.7351C88.138 31.6065 88.1075 30.4482 88.0488 29.2602H90.1642L90.2985 30.9333H90.3436C91.1446 29.6727 92.362 29.0435 93.9967 29.0435C95.2727 29.0435 96.3389 29.5352 97.1941 30.5197C98.0459 31.5053 98.4734 32.8011 98.4734 34.4082ZM96.023 34.494C96.023 33.4666 95.7849 32.6196 95.3088 31.953C94.7887 31.2578 94.0926 30.9102 93.216 30.9102C92.6214 30.9102 92.0833 31.1038 91.6004 31.4855C91.1175 31.8705 90.8028 32.3732 90.655 32.9958C90.5816 33.2862 90.5433 33.5238 90.5433 33.7108V35.4708C90.5433 36.2386 90.7847 36.8865 91.2653 37.4156C91.7482 37.9436 92.3755 38.2087 93.1494 38.2087C94.0554 38.2087 94.7605 37.8677 95.2648 37.1879C95.7703 36.507 96.023 35.6094 96.023 34.494Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M112.395 35.7105C112.395 36.9557 111.951 37.9688 111.061 38.7509C110.083 39.6056 108.721 40.0324 106.971 40.0324C105.356 40.0324 104.06 39.7288 103.08 39.1205L103.637 37.1658C104.693 37.7884 105.852 38.1008 107.115 38.1008C108.02 38.1008 108.726 37.9006 109.232 37.5024C109.736 37.1042 109.988 36.5696 109.988 35.903C109.988 35.309 109.78 34.8085 109.364 34.4026C108.95 33.9967 108.259 33.6194 107.293 33.2707C104.664 32.3148 103.351 30.9145 103.351 29.0731C103.351 27.8697 103.811 26.883 104.733 26.1152C105.651 25.3463 106.876 24.9624 108.409 24.9624C109.775 24.9624 110.91 25.1945 111.816 25.6576L111.214 27.5694C110.368 27.1206 109.412 26.8962 108.341 26.8962C107.495 26.8962 106.834 27.0997 106.36 27.5045C105.959 27.8664 105.758 28.3075 105.758 28.83C105.758 29.4086 105.987 29.8871 106.448 30.2633C106.848 30.6109 107.576 30.9871 108.632 31.393C109.924 31.9001 110.873 32.493 111.483 33.1728C112.091 33.8504 112.395 34.6985 112.395 35.7105Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "t_2",
    d: "M120.348 31.02H117.697V36.1449C117.697 37.4484 118.164 38.0996 119.1 38.0996C119.53 38.0996 119.887 38.0633 120.169 37.9907L120.235 39.7716C119.761 39.9443 119.138 40.0312 118.365 40.0312C117.415 40.0312 116.672 39.7485 116.137 39.1842C115.603 38.6188 115.334 37.6706 115.334 36.3385V31.0178H113.755V29.2578H115.334V27.3251L117.697 26.6299V29.2578H120.348V31.02Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "o_4",
    d: "M132.31 34.4509C132.31 36.0734 131.834 37.4055 130.884 38.4472C129.888 39.5197 128.566 40.0543 126.917 40.0543C125.329 40.0543 124.064 39.5406 123.121 38.5132C122.178 37.4858 121.706 36.1889 121.706 34.6258C121.706 32.9901 122.191 31.6503 123.165 30.6086C124.136 29.5658 125.447 29.0444 127.095 29.0444C128.684 29.0444 129.962 29.5581 130.927 30.5866C131.85 31.5843 132.31 32.8724 132.31 34.4509ZM129.814 34.5268C129.814 33.5533 129.601 32.7184 129.169 32.0221C128.665 31.1795 127.944 30.7593 127.01 30.7593C126.043 30.7593 125.308 31.1806 124.804 32.0221C124.372 32.7195 124.159 33.5676 124.159 34.5708C124.159 35.5443 124.372 36.3792 124.804 37.0744C125.324 37.917 126.051 38.3372 126.988 38.3372C127.907 38.3372 128.628 37.9082 129.148 37.0524C129.591 36.3429 129.814 35.4992 129.814 34.5268Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M140.129 31.3227C139.891 31.2798 139.637 31.2578 139.371 31.2578C138.525 31.2578 137.87 31.5691 137.41 32.1928C137.01 32.7428 136.809 33.438 136.809 34.2773V39.8158H134.405L134.427 32.5844C134.427 31.3678 134.397 30.2601 134.337 29.2613H136.432L136.52 31.2809H136.587C136.84 30.5868 137.241 30.028 137.789 29.6089C138.325 29.2316 138.904 29.0435 139.528 29.0435C139.75 29.0435 139.951 29.0589 140.129 29.0864V31.3227Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e_2",
    d: "M150.886 34.0383C150.886 34.4585 150.858 34.8127 150.798 35.102H143.582C143.61 36.1448 143.959 36.9423 144.629 37.4923C145.237 37.984 146.023 38.2304 146.989 38.2304C148.058 38.2304 149.032 38.0643 149.909 37.731L150.286 39.359C149.261 39.7946 148.052 40.0113 146.656 40.0113C144.978 40.0113 143.66 39.5295 142.701 38.567C141.744 37.6045 141.265 36.312 141.265 34.6906C141.265 33.0989 141.71 31.7734 142.603 30.7163C143.537 29.5877 144.799 29.0234 146.388 29.0234C147.948 29.0234 149.129 29.5877 149.932 30.7163C150.567 31.6128 150.886 32.7216 150.886 34.0383ZM148.592 33.43C148.608 32.7348 148.451 32.1342 148.125 31.6271C147.709 30.9748 147.069 30.6492 146.208 30.6492C145.422 30.6492 144.782 30.9671 144.294 31.6051C143.893 32.1122 143.655 32.7205 143.582 33.4289H148.592V33.43Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_751_4980",
    x: 0.5,
    y: 0,
    width: 178,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_751_4980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_751_4980",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_751_4980",
    x1: 12.5,
    y1: 28,
    x2: 166.5,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1035",
    style: {
      stopColor: "#1B1035",
      stopColor: "color(display-p3 0.1059 0.0627 0.2078)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04020A",
    style: {
      stopColor: "#04020A",
      stopColor: "color(display-p3 0.0176 0.0085 0.0392)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.0f3c86b0dedc5fae43299db5348a6865.svg";
export { ForwardRef as ReactComponent };